export const PHOTOFLIPPER_EVENTS = {
  SWIPE: 'photoflipper.carousel.swipe',
};
